import React from 'react'
import Routing from '../Routing/routing';
import SideNav from '../../SideNav/sideNav';

const Dashboard = () => {
    return (

        <>
            <div className="containers">
                <div className="navigation">
                    <SideNav />
                </div>
                <div className="main">
                    <Routing />
                </div>
            </div>


            {/* <div className="containers px-0 mx-0">
                <div className="row px-0 mx-0">
                <div className="navigation  col-xxl-2 col-xl-3 col-lg-4  d-lg-block d-none">
                    <SideNav />
                </div>
                <div className="main  col-xxl-10  col-xl-9 px-0 col-lg-8">
                    <Routing />
                </div>
                </div>
            </div> */}
        </>
    )
}

export default Dashboard;